/* eslint-disable */
/* eslint-env jquery */
jQuery(document).ready(function ($) {
  //
  jQuery('a.js-gtag-callback, .js-gtag-callback a').on('click', function (e) {
    e.preventDefault();
    gtag_report_conversion($(this).attr('href'));
  })
});
